export const NODE_MAP: WeakMap<HTMLElement, any> = new WeakMap<HTMLElement, any>();
